import React, { useState, useEffect, useRef } from 'react';
import { useLoader } from '../../../Loader/LoaderContext';
import { API_ENDPOINTS } from '../../../api';
import { deleteService, postService } from '../../../servce/ApisService';
import { PostDto } from '../../../api/interfaces/Posts';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { getServiceyName } from '../../../utility/RolesUtility';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useToaster } from '../../../Toaster/Toaster';
import Sucesspopup from '../Modals/SucessPopup';
interface PostManagementDto extends PostDto {
  // Optional properties or additional properties specific to PostManagementDto
}
const ItemType = 'POST';
const tabKeyMapping: Record<string, string> = {
  'Trending Now': 'TRENDING_NOW',
  'Newest Stories': 'NEWEST_STORIES',
  'Trending Topics': 'TRENDING_TOPICS',
  Services: 'IVF',
  Videos: 'VIDEOS',
  Events: 'EVENTS',
};
const tabKeyMap: Record<string, null | any> = {
  'Trending Now': 'TRENDING_NOW',
  'Newest Stories': 'NEWEST_STORIES',
  'Trending Topics': 'TRENDING_TOPICS',
  Services: null,
  Videos: 'VIDEOS',
  Events: 'EVENTS',
};

const serviceKeys = {
  IVF: 'IVF',
  ICSI: 'ICSI',
  IUI: 'IUI',
  'Sperm / Egg Freezing': 'SPERM_OR_EGG_FREEZING',
  Surrogacy: 'SURROGACY_CENTER',
};
const DraggableItem = ({
  item,
  index,
  moveItem,
  setData,
  fetchDetails,
  activeTab,
  selectedService
}: // closeMenu
{
  item: PostDto;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  setData: React.Dispatch<React.SetStateAction<PostDto[]>>;
  fetchDetails: () => void;
  activeTab: string;
  selectedService?: string
  // closeMenu:() =>void
}) => {
  const [isDragging, ref] = useDrag({
    type: ItemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem: { index: number }) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });
  const { setLoading } = useLoader();
  const { showToast } = useToaster();
  const deletePost = async (item: PostDto, activeTab: string) => {
    if (item?.selectedFromPostManagment) {
      // Remove item locally if it was added from Post Management
      setData((prevData: PostDto[]) =>
        prevData.filter((dataItem) => dataItem.id !== item.id)
      );
      showToast(
        'Post removed successfully from Post Management!',
        'success',
        ''
      );
    } else {
      try {
        let response: any;
        response = await deleteService(
          API_ENDPOINTS.deletePostOrder +
            '?postId=' +
            item?.id +
            '&postSection=' +
            (selectedService ? selectedService : tabKeyMapping[activeTab])
        );
        if (response.statusCode == 200) {
          setData((prevData: PostDto[]) =>
            prevData.filter((dataItem) => dataItem.id !== item.id)
          );
          showToast('Post deleted successfully!', 'success', '');
          fetchDetails();
          // closeMenu();
        }
      } catch (error: any) {
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <div
      ref={(node) => ref(drop(node))}
      key={item.id}
      style={{ cursor: 'grab' }} // Add cursor style
      className='bg-white pl-5 py-2.5 cursor-pointer border-b border-[#D1D5DB] flex items-center'
    >
      <div className='flex items-center flex-grow min-w-0'>
        <img src='/images/table_checkbox.svg' alt='Checkbox' />
        <p
          className='pl-9 mr-5 w-[95%] text-sm font-semibold overflow-hidden whitespace-nowrap min-w-0'
          style={{ textOverflow: 'ellipsis' }}
        >
          {item.title}
        </p>
      </div>
      <div className='flex items-center min-w-max ml-auto'>
        {/* <p className="w-2 h-2 border bg-gray-500 rounded-full"></p>
        <div className="flex items-center justify-start min-w-[165px]">
                  <p className="pl-3 text-[#B00A2B] text-sm font-normal">
                    {getServiceyName(item.category) || "NA"}
                  </p>
                </div> */}
        {item.category && getServiceyName(item.category) !== 'NA' && (
          <>
            <p className='w-2 h-2 border bg-gray-500 rounded-full'></p>
            <div className='flex items-center justify-start min-w-[165px]'>
              <p className='pl-3 text-[#B00A2B] text-sm font-normal'>
                {getServiceyName(item.category)}
              </p>
            </div>
          </>
        )}
        {item?.isOrderDeletable || item?.selectedFromPostManagment ? (
          <div
            className='flex items-center'
            onClick={() => deletePost(item, activeTab)}
          >
            <img
              src='/images/delete_icon.svg'
              alt='Delete Icon'
              className='mr-6 cursor-pointer'
            />
          </div>
        ) : (
          <div className='w-[40px]'></div> // This keeps space for the delete icon when it's absent
        )}
      </div>
    </div>
  );
};
const LandingPage = () => {
  const [hasMore, setHasMore] = useState(true);
  const [activeTab, setActiveTab] = useState('Trending Now');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState<{
    top: number;
    left: number;
  }>({ top: 0, left: 0 });

  const tabs = [
    'Trending Now',
    'Trending Topics',
    'Newest Stories',
    'Videos',
    'Services',
    'Events',
  ];
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [isShow, setIsShow] = useState(false);
  const [userId, setUserId] = useState(''); // Example user ID
  const [isPublish, setIsPublish] = useState(false); // Example publish status
  const [submittedData, setSubmittedData] = useState({ status: '' });
  const servicesTabRef = useRef<HTMLParagraphElement | null>(null);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const { setLoading } = useLoader();
  const { showToast } = useToaster();

  const closePopup = () => {
    setIsShow(false);
  };
  const viewUsers = () => {
    setIsShow(false);
    // navigate("/portals/contentCompanies/viewCompanies");
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
    setShowDropdown(true);
  };
  // const [selectedService, setSelectedService] = useState<string | null>(null);
  const [selectedService, setSelectedService] = useState<string>('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [datas, setData] = useState<PostDto[]>([]); // For table data
  const [responseData, setResponseData] = useState<PostManagementDto[]>([]);
  useEffect(() => {
    fetchDetails();
  }, [searchQuery, activeTab, selectedService, currentPage]);
  const handleServiceSelection = (service: keyof typeof serviceKeys) => {
    const backendKey = serviceKeys[service];
    console.log('Selected Service:', backendKey); // Log the key
    setIsMenuOpen(false);
    if(backendKey !== selectedService){
      setSelectedService(backendKey); // Store the backend key
      setCurrentPage(0);
      setData([]);
    }
    
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const postSection = selectedService || tabKeyMapping[activeTab];
      const body = {
        postSection, // Value for postSection
        postOrderDtos: datas.map((user: PostDto, index: number) => ({
          id: String(user.id), // Convert id to string (Long on backend)
          orderSeq: String(index + 1), // Convert orderSeq to string (Long on backend)
        })),
      };
      let url = API_ENDPOINTS.savePostManagement;
      const response = await postService(url, body);
      if (response?.data?.content) {
        if (searchQuery) {
          setResponseData(response.data.content);
        } else {
          setData(response.data.content);
        }
      }
      setSearchQuery('');
      setShowDropdown(true);
      showToast(
        'Post order has been successfully updated and saved!',
        'success',
        ''
      );
      fetchDetails();
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  const fetchDetails = async () => {
    try {
      setLoading(true);
      let postType: any;

      let url = API_ENDPOINTS.getPostManagement;

      const postSection = selectedService
        ? selectedService
        : tabKeyMapping[activeTab];

      const body = {
        search: searchQuery,
        isTableData: searchQuery ? false : true,
        postSection: postSection,
        postSectionFilter: postSection,
        serviceList: selectedService ? [selectedService] : [],
        postType:
          postSection === 'EVENTS'
            ? 'EVENT'
            : postSection === 'VIDEOS'
            ? undefined
            : undefined,
        postTypeList:
          postSection === 'VIDEOS'
            ? ['VIDEO', 'WEBINAR', 'INTERVIEW']
            : postSection === 'EVENTS'
            ? undefined
            : ['NEWS', 'ARTICLE', 'REPORT', 'WHITE_PAPER'],
        page: currentPage,
      };

      const response = await postService(url, body);
      if (response?.data?.content) {
        if (searchQuery) {
          setResponseData(response.data.content);
        } else {
          setData((prevData) => {
            const combinedData = [...prevData, ...response.data.content];
            return Array.from(
              new Map(combinedData.map((item) => [item.id, item])).values()
            );
          });
        }
        if (response.data.last) {
          setHasMore(false); // No more data to load
        } else {
          setHasMore(true); // There are more pages
        }
      }
      setShowDropdown(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setData([]); // Clear table data
    setCurrentPage(0); // Reset pagination
    fetchDetails(); // Fetch new tab data
  }, [activeTab]);

  const toggleMenu = () => {
    if (!isMenuOpen && servicesTabRef.current) {
      const rect = servicesTabRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setActiveTab('Services');
      setSelectedService((prev) => prev || 'IVF');
    }
  };
  const handleTabClick = (tab: string) => {
    if (tab !== 'Services') {
      setSelectedService(''); // Reset selected service if switching tabs
    }
    setActiveTab(tab);
    if (tab === 'Services') {
      toggleMenu();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);
  const moveItem = (dragIndex: number, hoverIndex: number) => {
    const updatedDatas = [...datas];
    const [draggedItem] = updatedDatas.splice(dragIndex, 1);
    updatedDatas.splice(hoverIndex, 0, draggedItem);
    setData(updatedDatas);
  };
  useEffect(() => {
    if (activeTab !== 'Services') {
      setIsMenuOpen(false);
    }
  }, [activeTab]);

  const handleSearchKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === 'Enter') {
      // viewMore();
    }
  };
  const getCategory: Record<string, string> = {
    IUI: 'IUI',
    IVF: 'IVF',
    HOSPITAL: 'Hospital',
    SURROGACY_CENTER: 'Surrogacy Center',
    ICSI: 'ICSI',
    SPERM_OR_EGG_FREEZING: 'Sperm/ Egg freezing',
  };
  const [name, setName] = useState('');
  // const handleAddToTable = (user: PostManagementDto, event: React.MouseEvent) => {
  //   event.stopPropagation(); // Prevent event propagation to parent elements

  //   // Check if the active tab is 'Trending Now' and there are already 5 records
  //   if (activeTab === "Trending Now" && datas.length >= 5) {
  //     setIsShow(true);
  //     setName('trendingNowLimit')

  //     return; // Prevent further execution
  //   }

  //   if (activeTab === "Videos" && datas.length >= 6) {
  //     setIsShow(true);
  //     setName('videoLimit')

  //     return;
  //   }

  //   // Update the table data
  //   setData((prevData) => {
  //     const updatedData = prevData.filter((item) => item.id !== user.id); // Remove old instance if exists
  //     return [{ ...user, selectedFromPostManagment: true }, ...updatedData]; // Add the new user to the beginning of the array
  //   });

  //   // Ensure the dropdown remains open
  //   setShowDropdown(true);

  //   // Show success toast
  //   showToast("Post added successfully!", "success", "");
  // };

  const handleAddToTable = (
    user: PostManagementDto,
    event: React.MouseEvent
  ) => {
    event.stopPropagation(); // Prevent event propagation to parent elements

    // Check if the active tab is 'Trending Now' and there are already 5 records
    if (activeTab === 'Trending Now' && datas.length >= 5) {
      setIsShow(true);
      setName('trendingNowLimit');
      return; // Prevent further execution
    }

    // Check if the active tab is 'Videos' and there are already 6 records
    if (activeTab === 'Videos' && datas.length >= 6) {
      setIsShow(true);
      setName('videoLimit');
      return; // Prevent further execution
    }

    // Check if the post already exists in the table
    const existingPostIndex = datas.findIndex((item) => item.id === user.id);
    if (existingPostIndex !== -1) {
      // Move the existing record to the beginning of the array
      setData((prevData) => {
        const updatedData = [...prevData];
        const [existingPost] = updatedData.splice(existingPostIndex, 1); // Remove existing post
        return [
          { ...existingPost, selectedFromPostManagment: true },
          ...updatedData,
        ];
      });

      // Show toaster message for already added post
      showToast(
        'This post has been already added. It will appear to first.',
        'success',
        ''
      );
      return; // Prevent further execution
    }

    // Update the table data for new posts
    setData((prevData) => [
      { ...user, selectedFromPostManagment: true },
      ...prevData,
    ]);

    // Ensure the dropdown remains open
    setShowDropdown(true);

    // Show success toaster
    showToast('Post added successfully!', 'success', '');
  };

  useEffect(() => {
    setSearchQuery(''); // Clear search query when tab changes
    setShowDropdown(false); // Optionally hide dropdown when tab changes
  }, [activeTab]);
  useEffect(() => {
    document.addEventListener('click', handleClickOutside as EventListener);
    return () => {
      document.removeEventListener(
        'click',
        handleClickOutside as EventListener
      );
    };
  }, []);
  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    console.log('scrollHeight:', event.currentTarget.scrollHeight);
    console.log('scrollTop:', event.currentTarget.scrollTop);
    console.log('clientHeight:', event.currentTarget.clientHeight);

    const tolerance = 5; // Adjust the tolerance as needed
    const bottom =
      event.currentTarget.scrollHeight -
        event.currentTarget.scrollTop -
        event.currentTarget.clientHeight <=
      tolerance;

    if (bottom && hasMore) {
      setCurrentPage((prevPage) => prevPage + 1); // Load the next page
    }
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (!(event.target as HTMLElement).closest('.search-container')) {
      setShowDropdown(false);
    }
  };
  const isPostAlreadyAdded = (postId: number) => {
    return datas.some((data) => data.id === postId);
  };

  return (
    <div>
      <div className='h-full py-2 w-full'>
        <div className='flex items-center cursor-pointer mb-6 font-sans text-sm'>
          <h2 className='mr-2 text-gray-700 font-semibold text-sm'>
            Post Management
          </h2>
          <img src='/images/arrowIcons.svg' className='mr-2' alt='Arrow Icon' />
          <span className='text-gray-400 font-semibold text-sm'>
            Landing Page
          </span>
        </div>
        <div className='relative mb-7 border-b-2 border-gray-200 font-Inter'>
          <div className='flex gap-7 items-center'>
            {tabs.map((tab) => (
              <div key={tab} className='flex items-center space-x-2'>
                {/* Tab Label */}
                <p
                  ref={tab === 'Services' ? servicesTabRef : null}
                  onClick={() => handleTabClick(tab)} // Tab click event
                  className={`cursor-pointer text-base pb-1 relative flex items-center gap-1 ${
                    activeTab === tab
                      ? 'font-medium text-[#B00A2B]'
                      : 'font-medium text-gray-700'
                  }`}
                >
                  {tab}

                  {/* Bottom border to highlight the active tab */}
                  {activeTab === tab && (
                    <span className='absolute left-0 bottom-0 w-full h-0.5 bg-[#B00A2B]'></span>
                  )}
                </p>

                {/* Render dropdown icon for 'Services' tab */}
                {tab === 'Services' && (
                  <img
                    src={
                      activeTab === 'Services'
                        ? '/images/ActiveRight_icon.svg'
                        : '/images/normal_rignt_icon.svg'
                    }
                    alt='Dropdown Icon'
                    className='h-4 w-4 cursor-pointer'
                    onClick={toggleMenu} // Only toggle menu for the 'Services' tab
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        {isMenuOpen && activeTab === 'Services' && (
          <div
            ref={menuRef}
            className='absolute bg-white border border-[#D1D5DB] rounded-md mt-2 w-full max-w-[200px] shadow-lg font-Inter font-medium text-base'
            style={{
              position: 'absolute',
              top: `${menuPosition.top}px`,
              left: `${menuPosition.left}px`,
              zIndex: 9999,
            }}
          >
            <ul className='cursor-pointer'>
              {Object.keys(serviceKeys).map((service) => (
                <li
                  key={service}
                  className={`px-4 py-2  hover:bg-[#FFF7F7] font-Inter font-medium text-base ${
                    selectedService ===
                    serviceKeys[service as keyof typeof serviceKeys]
                      ? 'bg-gray-300 text-[#B00A2B]'
                      : 'text-gray-700'
                  }`}
                  onClick={() =>
                    handleServiceSelection(service as keyof typeof serviceKeys)
                  }
                >
                  {service}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className='flex items-center mb-7'>
          <h1 className='text-2xl whitespace-nowrap font-bold mb-2 text-[#2D2E2F] mr-3'>
            {activeTab}
          </h1>
          <div className='relative w-full'>
            <input
              type='text'
              placeholder='Search for post by Title/ID/Tag'
              className='hidden md:flex p-2 pl-10 border-[#D1D5DB] w-full rounded-md border-2 mr-4 focus:border-[#B00A2B] focus:outline-none'
              onChange={handleSearch}
              value={searchQuery}
            />
            <span className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'>
              <img src='/images/searchIcon.svg' />
            </span>
            {showDropdown && searchQuery && (
              <div className='absolute left-0 w-full mt-2 bg-white border border-gray-200 rounded-md shadow-lg z-10 font-Inter'>
                <ul className='max-h-60 overflow-y-auto'>
                  {responseData.map((user: PostManagementDto) => (
                    <div
                      key={user.id}
                      className='bg-white pl-4 pr-4 py-2 flex items-center flex-wrap sm:flex-nowrap'
                    >
                      <div className='flex items-center font-medium text-sm flex-grow min-w-0'>
                        <p
                          className='mr-5 overflow-hidden whitespace-nowrap text-ellipsis'
                          style={{ textOverflow: 'ellipsis' }}
                        >
                          {user.title}
                        </p>
                      </div>
                      <div className='flex items-center min-w-max ml-auto space-x-4'>
                        {/* <p className="w-2 h-2 border bg-gray-500 rounded-full"></p>
                      <div className="flex items-center justify-start min-w-[140px] sm:min-w-[165px]">
                      <p className="font-normal text-sm text-[#B00A2B] truncate">
                        {getCategory[user?.category] || "NA"}
                      </p>
                    </div> */}
                        {user.category &&
                          getServiceyName(user.category) !== 'NA' && (
                            <>
                              <p className='w-2 h-2 border bg-gray-500 rounded-full'></p>
                              <div className='flex items-center justify-start min-w-[165px]'>
                                <p className='pl-3 text-[#B00A2B] text-sm font-normal'>
                                  {getServiceyName(user.category)}
                                </p>
                              </div>
                            </>
                          )}
                        <div className='flex items-center justify-end'>
                          {/* {!isPostAlreadyAdded(user.id) ? ( */}
                          <img
                            src='/images/plus_Icon.svg'
                            alt='Plus Icon'
                            className='cursor-pointer'
                            onClick={(e) => handleAddToTable(user, e)}
                          />
                          {/* ) : (
                          <div className="w-[15px] h-5"></div>
                        )} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className='border border-[#D1D5DB] '>
          <div className='font-sans'>
            <div className='bg-[#FFF7F7] pl-5 py-2 border-b border-[#D1D5DB] flex rounded-tr-md rounded-tl-md'>
              <p className='pl-14 font-semibold text-base'>Title</p>
            </div>
            <div
              className='justify-between scroolCls h-[60vh] overflow-y-scroll'
              onScroll={handleScroll}
            >
              {datas.length > 0 ? (
                <DndProvider backend={HTML5Backend}>
                  <div>
                    {datas.map((user: PostDto, index) => (
                      <DraggableItem
                        key={user.id}
                        item={user}
                        index={index}
                        moveItem={moveItem}
                        setData={setData}
                        fetchDetails={fetchDetails}
                        activeTab={activeTab}
                        selectedService={selectedService}
                        // closeMenu={closeMenu}
                      />
                    ))}
                  </div>
                </DndProvider>
              ) : (
                <div className='text-center py-4 font-semibold text-gray-500'>
                  No data to show
                </div>
              )}
            </div>
          </div>
          {/* {!(showDropdown && searchQuery) && ( */}
          <div className='fixed bottom-[10px] w-[78%]'>
            <div
              className='flex justify-end mt-4 p-4 items-center bg-white mb-[-10px]'
              style={{
                boxShadow: '0px -16px 50px 0px #0000000D',
              }}
            >
              <button
                type='submit'
                onClick={handleSave}
                // disabled={!isValid || isSubmitting || isBollen}
                className={`px-4 py-2 gradient-background width-[87px] text-white rounded font-bold text-base`}
              >
                Save
              </button>
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
      {isShow && (
        <Sucesspopup
          addUser={closePopup}
          viewUser={viewUsers}
          emailId={''}
          name={name}
          isUpdate={userId ? 'update' : 'add'}
          nameOfScreen='trendingNow'
          isApproval={isPublish ? 'approval' : 'draft'}
          statusValue={submittedData?.status || ''}
          download={function (): void {
            throw new Error('Function not implemented.');
          }}
          upload={function (): void {
            throw new Error('Function not implemented.');
          }}
          confirm={function (): void {
            throw new Error('Function not implemented.');
          }}
        />
      )}
    </div>
  );
};

export default LandingPage;
